module.exports = __webpack_public_path__ + "48257b86f1c31d9858de812cc19f1656.fbx";